<script>
  export let type;
  export let css="";

  let uid = Math.random().toString(36).substring(2);
</script>

{#if type == '1'}
  <!--ProductItem-->
  <svg
    role="img"
    class="w-full h-full"
    style={css}
    
    viewBox="0 0 155 190"
    preserveAspectRatio="none">
    <title id="loading-aria-{uid}">Loading...</title>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      clip-path="url(#clip-path-1-{uid})"
      style="fill: url('#1-{uid}');" />
    <defs>
      <clipPath id="clip-path-1-{uid}">
        <rect x="0" y="0" rx="0" ry="0" width="155" height="100" />
        <rect x="11" y="106" rx="2" ry="2" width="129" height="8" />
        <rect x="12" y="117" rx="2" ry="2" width="110" height="8" />
        <rect x="12" y="132" rx="2" ry="2" width="65" height="8" />
        <rect x="12" y="145" rx="2" ry="2" width="129" height="5" />
        <rect x="12" y="153" rx="2" ry="2" width="110" height="5" />
      </clipPath>
      <linearGradient id="1-{uid}">
        <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="1.59996" stop-color="#ecebeb" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
  </svg>
{/if}
{#if type == '2'}
  <!--ProductDetail-->
  <svg
    role="img"
    class="w-full h-full"
    
    viewBox="0 0 560 450"
    preserveAspectRatio="none"
    style={css}>
    <title id="loading-aria-{uid}">Loading...</title>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      clip-path="url(#clip-path-2-{uid})"
      style="fill: url('#fill-2-{uid}');" />
    <defs>
      <clipPath id="clip-path-2-{uid}">
        <rect x="4" y="14" rx="4" ry="4" width="188" height="20" />
        <rect x="4" y="49" rx="4" ry="4" width="500" height="25" />
        <rect x="4" y="96" rx="4" ry="4" width="146" height="25" />
        <rect x="20" y="138" rx="10" ry="10" width="86" height="25" />
        <rect x="119" y="138" rx="10" ry="10" width="50" height="25" />
        <rect x="143" y="187" rx="10" ry="10" width="133" height="31" />
        <rect x="50" y="187" rx="10" ry="10" width="50" height="31" />
        <circle cx="118" cy="202" r="8" />
        <circle cx="33" cy="202" r="8" />
        <rect x="6" y="234" rx="2" ry="2" width="213" height="25" />
        <rect x="6" y="266" rx="2" ry="2" width="268" height="17" />
        <rect x="6" y="305" rx="2" ry="2" width="448" height="15" />
        <rect x="6" y="326" rx="2" ry="2" width="435" height="15" />
        <rect x="6" y="348" rx="2" ry="2" width="278" height="15" />
        <circle cx="46" cy="415" r="33" />
        <rect x="87" y="388" rx="2" ry="2" width="47" height="12" />
        <rect x="87" y="406" rx="2" ry="2" width="135" height="15" />
        <rect x="106" y="428" rx="2" ry="2" width="100" height="12" />
        <circle cx="95" cy="434" r="7" />
      </clipPath>
      <linearGradient id="fill-2-{uid}">
        <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="1.59996" stop-color="#ecebeb" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
  </svg>
{/if}
{#if type == '3'}
  <!--Shop Info-->
  <svg
    role="img"
    class="w-full h-full"
    
    viewBox="0 0 290 90"
    preserveAspectRatio="none"
    style={css}>
    <title id="loading-aria-{uid}">Loading...</title>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      clip-path="url(#clip-path-3-{uid})"
      style="fill: url('#3-{uid}');" />
    <defs>
      <clipPath id="clip-path-3-{uid}">
        <circle cx="52" cy="45" r="43" />
        <rect x="106" y="10" rx="2" ry="2" width="61" height="15" />
        <rect x="106" y="33" rx="2" ry="2" width="175" height="20" />
        <rect x="130" y="62" rx="2" ry="2" width="130" height="15" />
        <circle cx="116" cy="69" r="9" />
      </clipPath>
      <linearGradient id="3-{uid}">
        <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="1.59996" stop-color="#ecebeb" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
  </svg>
{/if}
{#if type == '4'}
  <!--Pictures ProductDetail-->
  <svg
    role="img"
    class="w-full h-full"
    
    viewBox="0 0 450 540"
    preserveAspectRatio="none">
    <title id="loading-aria-{uid}">Loading...</title>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      clip-path="url(#clip-path-4-{uid})"
      style="fill: url('#fill-4-{uid}');" />
    <defs>
      <clipPath id="clip-path-4-{uid}">
        <rect x="0" y="19" rx="5" ry="5" width="440" height="440" />
        <rect x="65" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="147" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="230" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="312" y="470" rx="5" ry="5" width="58" height="61" />
      </clipPath>
      <linearGradient id="fill-4-{uid}">
        <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="1.59996" stop-color="#ecebeb" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs>
  </svg>
{/if}
{#if type == '5'}
  <!--News-->
  <svg
    role="img"
    class="w-full h-full"
    
    viewBox="0 0 280 60"
    preserveAspectRatio="none"><title id="loading-aria-{uid}">Loading...</title>
    <rect
      x="0"
      y="0"
      width="100%"
      height="100%"
      clip-path="url(#clip-path-5-{uid})"
      style="fill: url(#fill-5-{uid});" />
    <defs>
      <clipPath id="clip-path-5-{uid}">
        <rect x="65" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="147" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="230" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="312" y="470" rx="5" ry="5" width="58" height="61" />
        <rect x="2" y="45" rx="5" ry="5" width="200" height="12" />
        <rect x="2" y="25" rx="5" ry="5" width="275" height="12" />
        <rect x="2" y="2" rx="5" ry="5" width="57" height="10" />
        <rect x="190" y="2" rx="5" ry="5" width="87" height="14" />
      </clipPath>
      <linearGradient id="fill-5-{uid}">
        <stop offset="0.599964" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-2; -2; 1"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="1.59996" stop-color="#ecebeb" stop-opacity="1">
          <animate
            attributeName="offset"
            values="-1; -1; 2"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
        <stop offset="2.59996" stop-color="#f3f3f3" stop-opacity="1">
          <animate
            attributeName="offset"
            values="0; 0; 3"
            keyTimes="0; 0.25; 1"
            dur="2s"
            repeatCount="indefinite" />
        </stop>
      </linearGradient>
    </defs></svg>
{/if}
{#if type == '6'}
<!--form-->
<svg
  role="img"
  class="w-full h-full" 
  
  viewBox="0 0 560 370"
  preserveAspectRatio="none"
>
  <title id="loading-aria-{uid}">Loading...</title>
  <rect
    x="0"
    y="0"
    width="100%"
    height="100%"
    clip-path="url(#clip-path-6-{uid})"
    style='fill: url("#fill-6-{uid}");'
  ></rect>
  <defs>
    <clipPath id="clip-path-6-{uid}">
        <rect x="8" y="3" rx="5" ry="5" width="150" height="20" /> 
        <rect x="6" y="36" rx="5" ry="5" width="171" height="24" /> 
        <rect x="9" y="114" rx="5" ry="5" width="539" height="50" /> 
        <rect x="27" y="103" rx="5" ry="5" width="176" height="14" /> 
        <rect x="9" y="236" rx="5" ry="5" width="539" height="50" /> 
        <rect x="27" y="225" rx="5" ry="5" width="176" height="14" /> 
        <rect x="50" y="193" rx="5" ry="5" width="458" height="18" /> 
        <rect x="9" y="314" rx="5" ry="5" width="173" height="49" />
    </clipPath>
    <linearGradient id="fill-6-{uid}">
      <stop
        offset="0.599964"
        stop-color="#f3f3f3"
        stop-opacity="1"
      >
        <animate
          attributeName="offset"
          values="-2; -2; 1"
          keyTimes="0; 0.25; 1"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </stop>
      <stop
        offset="1.59996"
        stop-color="#ecebeb"
        stop-opacity="1"
      >
        <animate
          attributeName="offset"
          values="-1; -1; 2"
          keyTimes="0; 0.25; 1"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </stop>
      <stop
        offset="2.59996"
        stop-color="#f3f3f3"
        stop-opacity="1"
      >
        <animate
          attributeName="offset"
          values="0; 0; 3"
          keyTimes="0; 0.25; 1"
          dur="2s"
          repeatCount="indefinite"
        ></animate>
      </stop>
    </linearGradient>
  </defs>
</svg>
{/if}
